module.exports = __webpack_public_path__ + "img/banner2_9_en.9ff26850.png";